import React from 'react';

const SocialIcon = ({children}) => {
    return ( 
        <div className='flex rounded-full justify-center items-center p-2 border border-gray-300 hover:bg-gray-300 hover:text-white cursor-pointer'>{ children}</div>
     );
}

export default SocialIcon;